import * as deposit from '@sitebase/pre-integrated-features/deposit';
import * as subNavEnd from '@sitebase/pre-integrated-features/sub-nav-end';
import * as subNavEndLanguageMenu from '@sitebase/pre-integrated-features/sub-nav-end-language-menu';
import * as subNavStart from '@sitebase/pre-integrated-features/sub-nav-start';

export const piHeaderRenderers = [
  ...deposit.renderers,
  ...subNavEnd.renderers,
  ...subNavEndLanguageMenu.renderers,
  ...subNavStart.renderers,
];
